import {
  useBrokersServiceBrokersUsersListKey,
  useBrokersServiceBrokersUsersRetrieveKey,
  useBrokersServiceBrokersUsersSetStatusCreate
} from '@insurance/api/queries'
import { AgentStatuses } from '@insurance/types'
import { showApiErrors } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import { App, Switch } from 'antd'
import { useTranslation } from 'react-i18next'

import { CommonPropsAgent } from './types'

type Props = Required<Pick<CommonPropsAgent, 'data'>>

export const SetAgentStatus = ({ data }: Props) => {
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const { t } = useTranslation()

  const isActive = data.status === AgentStatuses.ACTIVE

  const { mutate, isPending } = useBrokersServiceBrokersUsersSetStatusCreate({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useBrokersServiceBrokersUsersListKey]
      })
      queryClient.invalidateQueries({
        queryKey: [useBrokersServiceBrokersUsersRetrieveKey, { id: data?.id }]
      })

      message.success(t('edited_successfully'))
    },
    onError: (error) => showApiErrors(error)
  })

  const onSwitch = () => {
    mutate({ id: Number(data.id), requestBody: { is_active: !isActive } })
  }

  return <Switch checked={isActive} loading={isPending} onChange={onSwitch} />
}
